import React from "react";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import TermsFiles from "components/terms-and-conditions/terms-files";

const TermsAndConditions = () => (
  <Layout className="terms-and-conditions" title="Terms & conditions">
    <Header>
      <HeaderBanner
        title="Terms & conditions"
        icon="faq"
        background="/static/images/header-balcony.jpg"
      />
    </Header>
    <Breadcrumbs>
      <Breadcrumbs.Item title="Terms & conditions" url="terms-and-conditions" />
    </Breadcrumbs>
    <TermsFiles />
  </Layout>
);

export default asPage(TermsAndConditions);
